import React from 'react';
import { Text } from '@ui/atoms/Text';
import { buildingPath } from '@routes';
export default function BuildingNameCell({ tdProps, dataItem }) {
    if (!dataItem.buildingId) {
        return (React.createElement("td", Object.assign({}, tdProps),
            React.createElement(Text, null, dataItem.buildingName)));
    }
    return (React.createElement("td", Object.assign({}, tdProps),
        React.createElement(Text, { variant: "link", as: "a", href: buildingPath(dataItem.buildingId), target: "_blank", rel: "noopener noreferrer" }, dataItem.buildingName)));
}
